import { useSelector } from 'react-redux';
import { RootState } from '../../redux';
import { Box } from '@mui/material';
import { palette } from '../..';
import { useState } from 'react';
import CustomQueryEditor from './CustomQueryEditor';
import { ISelectedTable } from '../../redux/_Dataset/types';
import QueryTable from './QueryTable';
import { RemoveArrow } from '../../redux/_Dataset/dataset.action';
import { useDispatch } from 'react-redux';

function CustomQuery() {
  const { customQueryTables, ConnectionInfo, canEdit, arrows } = useSelector((state: RootState) => {
    const selectedConnection = state.dataset.selectedConnectionId;
    return {
      canEdit: state.dataset.canEdit,
      customQueryTables: state.dataset.selectedTables.filter(
        (table) => table.isCustomQuery && selectedConnection === table.connectionId,
      ),
      ConnectionInfo: state.dataset.connections.find(
        (connection) => connection.id === selectedConnection,
      )!,
      arrows: state.dataset.arrows,
    };
  });
  const dispatch = useDispatch();
  const [showEditor, setShowEditor] = useState(false);
  const [editorMode, setEditorMode] = useState<'edit' | 'new'>('new');
  const [tableInfo, setTableInfo] = useState<ISelectedTable | null>(null);
  const onEditorClose = () => {
    setShowEditor(false);
    setEditorMode('new');
  };
  const onEdit = (table: ISelectedTable) => {
    if (!canEdit) return;
    setTableInfo(table);
    setShowEditor(true);
    setEditorMode('edit');
  };
  const onDelete = (table: ISelectedTable) => {
    const arrowIdsToBeDeleted = [
      ...new Set(
        arrows
          .filter((arrow) => arrow.startId === table.id || arrow.endId === table.id)
          .map((arrow) => arrow.arrowId),
      ),
    ];
    dispatch(RemoveArrow(arrowIdsToBeDeleted));
  };

  return (
    <Box>
      <Box
        sx={{
          mb: 1,
        }}
      >
        {customQueryTables.map((table) => (
          <QueryTable
            table={table}
            onEdit={onEdit}
            canEdit={canEdit}
            onDelete={onDelete}
            vendor={ConnectionInfo?.vendor ?? ''}
          />
        ))}
      </Box>
      <button
        className="add-query-btn"
        onClick={() => {
          if (!canEdit) return;
          setEditorMode('new');
          setShowEditor(true);
        }}
        // disabled={viewerRestriction}
        style={{
          // color: palette.primary.main,
          padding: '2%',
          position: 'relative',
          width: '100%',
          outlineColor: palette.primary.main,
          outline: `1px solid ${palette.primary.main}`,
          border: 'none',
          borderRadius: '0.2rem',
          marginTop: '0.3rem',
          // cursor: viewerRestriction ? 'not-allowed' : 'pointer',
        }}
      >
        Add
      </button>
      {showEditor && (
        <CustomQueryEditor
          isNew={editorMode === 'new'}
          onEditorClose={onEditorClose}
          connection={ConnectionInfo}
          tableInfo={editorMode === 'edit' ? tableInfo : null}
        />
      )}
    </Box>
  );
}
export default CustomQuery;
